import View from "./View";

const RisksDrawer = ({ open, onClose }) => {
  return <View onClose={onClose} open={open} />;
};

export default RisksDrawer;
